import { render, staticRenderFns } from "./DashboardWelcomeCard.vue?vue&type=template&id=3f75573c&scoped=true&"
import script from "./DashboardWelcomeCard.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcomeCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWelcomeCard.vue?vue&type=style&index=0&id=3f75573c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75573c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VChip,VCol,VRow})
